import { Injectable, Injector } from '@angular/core'
import { Observable } from 'rxjs/Observable'

import { BaseModelService } from './base-model.service'
import { User } from './user.model'
import { UserSerializer } from 'serializers'
import { KeyTransformer } from 'util/key-transformer'

export interface UserMassUpdateParams {
  users: {
    firstname: string
    lastname: string
    email: string
    password: string
  }[]
  centerIds?: number[]
  roles: string[]
  permissions: string[]
}

export interface UserMassUpdateResponse {
  updatedCount: number
  createdUsers: {
    firstname: string
    lastname: string
    email: string
    password: string
  }[]
}

@Injectable()
export class UserService extends BaseModelService<User> {
  constructor() {
    super()

    this.configure({
      basePath:  'users',
      key:       'user',
      pluralKey: 'users',
      serializer: UserSerializer
    })
  }

  accessorCounters(accessorId: number): Observable<Object> {
    let url = this.buildUrl(accessorId, 'counters', 'accessor')
    return this.get(url)
  }

  massUpdate(params: UserMassUpdateParams): Observable<UserMassUpdateResponse> {
    const url = this.buildUrl('mass_update')
    const body = JSON.stringify(KeyTransformer.underscore(params))

    return this.appHttp.patch(url, body)
      .map(resp => this.processResponse(resp))
      .map(resp => resp as UserMassUpdateResponse)
  }

  savePersonalData(user: User, data): Observable<Object> {
    user.firstname = data.firstname
    user.lastname = data.lastname
    return this.save(user)
  }

  changePassword(user: User, password): Observable<Object> {
    let url = this.buildUrl(user.id, 'change_password')
    return this.appHttp.patch(url, password).map(response => this.processResponse(response))
  }

  resetPassword(user: User): Observable<Object> {
    let url = this.buildUrl(user.id, 'reset_password')
    return this.appHttp.patch(url, null).map(response => this.processResponse(response))
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/models/user.service.ts